// PGCET MCA Mock 5 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "The Fundamental Duties of citizens are contained in which Part of the Constitution of India?",
    options: ["A. Part III", "B. Part IV", "C. Part IV-A", "D. Part V"],
    answer: "C"
  },
  {
    id: 72,
    question: "A Money Bill can be introduced only in the",
    options: ["A. Lok Sabha", "B. Rajya Sabha", "C. either House of Parliament", "D. joint sitting of both Houses"],
    answer: "A"
  },
  {
    id: 73,
    question: "The writ issued by a court directing that a detained person be produced before it, so that the legality of the detention can be examined, is",
    options: ["A. Mandamus", "B. Certiorari", "C. Quo Warranto", "D. Habeas Corpus"],
    answer: "D"
  },
  {
    id: 74,
    question: "The Annual Financial Statement (Union Budget) is laid before Parliament under Article",
    options: ["A. 110", "B. 112", "C. 280", "D. 360"],
    answer: "B"
  },
  {
    id: 75,
    question: "The Reserve Bank of India was nationalised in",
    options: ["A. 1935", "B. 1947", "C. 1949", "D. 1969"],
    answer: "C"
  },
  {
    id: 76,
    question: "The headquarters of the World Trade Organization (WTO) is located in",
    options: ["A. Geneva", "B. Washington, D.C.", "C. New York", "D. Paris"],
    answer: "A"
  },
  {
    id: 77,
    question: "The Small Industries Development Bank of India (SIDBI) is the principal development financial institution for",
    options: [
      "A. agriculture and rural development",
      "B. the micro, small and medium enterprises (MSME) sector",
      "C. housing finance",
      "D. export-import trade"
    ],
    answer: "B"
  },
  {
    id: 78,
    question: "The minimum age required to be elected as the President of India is",
    options: ["A. 25 years", "B. 30 years", "C. 21 years", "D. 35 years"],
    answer: "D"
  },
  {
    id: 79,
    question: "Which gas makes up the largest share of the Earth's atmosphere by volume?",
    options: ["A. Nitrogen", "B. Oxygen", "C. Argon", "D. Carbon dioxide"],
    answer: "A"
  },
  {
    id: 80,
    question: `Consider the following statements about the Vice-President of India.
      (a) The Vice-President is the ex-officio Chairman of the Rajya Sabha.
      (b) The Vice-President is elected by an electoral college consisting of members of both Houses of Parliament.
      (c) Members of the State Legislative Assemblies also vote in the election of the Vice-President.
      Which of the statements are correct?`,
    options: ["A. (a) only", "B. (a) and (b) only", "C. (b) and (c) only", "D. (a), (b) and (c)"],
    answer: "B"
  },
  {
    id: 81,
    question: "Which blood components help in the clotting of blood?",
    options: ["A. Red blood cells", "B. White blood cells", "C. Platelets", "D. Plasma proteins only"],
    answer: "C"
  },
  {
    id: 82,
    question: "The ozone layer that protects the Earth from ultraviolet radiation lies mainly in the",
    options: ["A. Troposphere", "B. Mesosphere", "C. Thermosphere", "D. Stratosphere"],
    answer: "D"
  },
  {
    id: 83,
    question: "The largest gland in the human body is the",
    options: ["A. Liver", "B. Pancreas", "C. Thyroid", "D. Pituitary"],
    answer: "A"
  },
  {
    id: 84,
    question: "The Palk Strait separates India from",
    options: ["A. Maldives", "B. Sri Lanka", "C. Myanmar", "D. Bangladesh"],
    answer: "B"
  },
  {
    id: 85,
    question: "The highest peak in Karnataka is",
    options: ["A. Kudremukh", "B. Kodachadri", "C. Mullayanagiri", "D. Nandi Hills"],
    answer: "C"
  },
  {
    id: 86,
    question: "Hampi, the UNESCO World Heritage Site in Karnataka, lies on the banks of the river",
    options: ["A. Kaveri", "B. Krishna", "C. Sharavati", "D. Tungabhadra"],
    answer: "D"
  },
  {
    id: 87,
    question: "The Battle of Plassey was fought in",
    options: ["A. 1757", "B. 1764", "C. 1761", "D. 1857"],
    answer: "A"
  },
  {
    id: 88,
    question: "The Satyashodhak Samaj was founded in 1873 by",
    options: ["A. Raja Ram Mohan Roy", "B. Jyotirao Phule", "C. Swami Dayananda Saraswati", "D. B. R. Ambedkar"],
    answer: "B"
  },
  {
    id: 89,
    question: "Mysore State was renamed Karnataka in",
    options: ["A. 1956", "B. 1960", "C. 1973", "D. 1980"],
    answer: "C"
  },
  {
    id: 90,
    question: `Match the art forms in List-I with the states in List-II.
      List-I: (a) Yakshagana (b) Kathakali (c) Kuchipudi (d) Bihu
      List-II: (i) Assam (ii) Andhra Pradesh (iii) Karnataka (iv) Kerala`,
    options: [
      "A. a-iv, b-iii, c-ii, d-i",
      "B. a-iii, b-ii, c-iv, d-i",
      "C. a-iii, b-iv, c-i, d-ii",
      "D. a-iii, b-iv, c-ii, d-i"
    ],
    answer: "D"
  }
];

export default pgcetmcaGeneralAwareness;
